// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e0d6a65b","453":"790589bb","455":"6fd67279","879":"5888f7ec"}[chunkId] + ".chunk.js";
};